'use strict';

angular.module('admin.language', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.languages', {
        url: 'languages',
        model: 'Language',
        viewOptions: 'languageViewOptions',
        title: 'Languages',
        modelNameField: 'name',
        edit: {
            templateUrl: 'admin/language/language.edit.html',
            controller: 'LanguageAdminCtrl',
            defaults: {
                display_order: 1,
            }
        },
    });
})

.factory('languageViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    listView
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        queryDefaults: {
            sort: [
                ['id', 'DESC'],
            ],
        },
        list: {
            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    sortable: true,
                },
                {
                    label: 'Code',
                    name: 'code',
                    template: '<span><span class="flag-icon flag-icon-squared flag-icon-{{model.code}}"></span> {{ model.code }}</div></span>',
                    sortable: true,
                },
                {
                    label: 'Enabled',
                    name: 'enabled',
                    template: '<span class="no-wrap">{{ model.enabled ? "Yes" : "No"}}</span>',
                    sortable: true,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        views: [listView],
    });
});
